import { ClientEvent, type MatrixClient } from 'matrix-js-sdk/src/matrix';
import { useEffect, useState } from 'react';

/** Matrix IndexedDB cache is untrusted until the first server sync has merged. */
export const isMatrixShellStateReady = (matrixClient: MatrixClient): boolean => matrixClient.isInitialSyncComplete();

/** Re-renders when initial sync completes so shell UI can gate on trustworthy Matrix state. */
export const useMatrixShellReadyState = (matrixClient: MatrixClient): boolean => {
  const [matrixReady, setMatrixReady] = useState(() => isMatrixShellStateReady(matrixClient));

  useEffect(() => {
    if (matrixReady) return;

    const onSync = () => {
      if (isMatrixShellStateReady(matrixClient)) {
        setMatrixReady(true);
      }
    };

    if (isMatrixShellStateReady(matrixClient)) {
      setMatrixReady(true);
      return;
    }

    matrixClient.on(ClientEvent.Sync, onSync);
    return () => {
      matrixClient.off(ClientEvent.Sync, onSync);
    };
  }, [matrixClient, matrixReady]);

  return matrixReady;
};
